import React, { useState, useEffect, useCallback } from 'react';
import Specialty from '../../../../forms/specialty';
import restApiClient from '../../../../services/restApiClient';
import CrudTable from '../../../../components/crudTable';
import FilterTree from '../../../../helpers/filterTree';
import { Container, Receipt } from './styles';
import ExpenseTypeDialog from '../../../../components/expenseTypeDialog';
import CreateUpdateGroupDialog from '../../../../components/createUpdateGroupDialog';

function SpecialtyView({ history }) {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderBy, setOrderby] = useState({ name: 'asc' });
  const [searchBy, setSearchBy] = useState('');
  const [openExpenseTypeDialog, setOpenExpenseTypeDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(undefined);
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState({
    key: '',
    actionLabel: '',
    depthLabel: '',
  });
  const columns = Specialty.listSchema;

  const loadSpecialties = useCallback(() => {
    restApiClient.specialty
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy ? new FilterTree().like('name', searchBy).toString() : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    loadSpecialties();
  }, [loadSpecialties]);

  return (
    <Container>
      <CrudTable
        title={'Cadastro de Especialidades'}
        modelActions={Specialty.actions}
        columns={columns}
        rows={rows}
        page={page}
        setPage={(page) => setPage(page)}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
        onOrderByChange={(orderBy) => setOrderby(orderBy)}
        orderBy={orderBy}
        setOrderBy={(value) => setOrderby(value)}
        searchBy={searchBy}
        setSearchBy={(value) => setSearchBy(value)}
        actions={{
          add: {
            onClick: () => {
              setOpen(true);
              setAction({
                key: 'add',
                actionLabel: 'Cadastro',
                depthLabel: 'Especialidade',
              });
            },
          },
          update: {
            onClick: (paymentTypeId) => {
              setSelectedId(paymentTypeId);
              setOpen(true);
              setAction({
                key: 'edit',
                actionLabel: 'Edição',
                depthLabel: 'Especialidade',
              });
            },
            allowedActions: [
              [Specialty.actions.findById, Specialty.actions.update],
            ],
          },
          link: {
            icon: <Receipt />,
            onClick: (id, depth, actionKey) => {
              setSelectedId(id);
              setOpenExpenseTypeDialog(true);
            },
            maxDepth: 2,
            title: 'Vincular a um tipo de despesa',
            allowedActions: [
              [Specialty.actions.findById, Specialty.actions.update],
            ],
          },
          delete: {
            onClick: (paymentTypeId, index) => {
              restApiClient.specialty.delete(paymentTypeId).then(() => {
                const result = { ...rows };
                if (index > -1) {
                  result.values.splice(index, 1);
                  result.count--;
                }
                setRows(result);
              });
            },
          },
        }}
        customCellRenderers={{
          expenseType: {
            renderer: (field, value) => {
              if (value?.parent?.parent?.parent) {
                return `${value.parent.parent.parent.name} > ${value.parent.parent.name} > ${value.parent.name} > ${value.name}`;
              } else if (value?.parent?.parent) {
                return `${value.parent.parent.name} > ${value.parent.name} > ${value.name}`;
              } else if (value?.parent) {
                return `${value.parent.name} > ${value.name}`;
              } else {
                return value?.name ?? '-';
              }
            },
          },
        }}
      />

      <ExpenseTypeDialog
        open={openExpenseTypeDialog}
        selectedId={selectedId}
        restModel={restApiClient.specialty}
        onClose={() => {
          setOpenExpenseTypeDialog(false);
        }}
        onSuccess={() => {
          loadSpecialties();
          setOpenExpenseTypeDialog(false);
        }}
      />

      <CreateUpdateGroupDialog
        open={open}
        restModel={restApiClient.specialty}
        action={action}
        parentId={selectedId}
        onCancel={() => {
          setOpen(false);
          setSelectedId(undefined);
        }}
        onSuccess={() => {
          loadSpecialties();
          setOpen(false);
        }}
      />
    </Container>
  );
}

export default SpecialtyView;
